import classnames from 'classnames';
import OText from 'components/CText/OText';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { useSeenModulePixel } from 'hook/helper.hook';
import { goToUrlWithNewTab } from 'helpers/domHelper';
import { EQF, EXP } from 'types/creditReport.constants';

const DiscrepancyController = props => {
  const {
    datatestid,
    reportId,
    title,
    subtitle,
    bureaus,
    sectionIds,
    panelKey,
    enableToDispute,
    subSectionsBlueMessage,
    handleOpenPanel,
    handleResolveNow,
    DiscrepancyRow,
    modulePosition,
    whatsDifferentConfig,
  } = props;
  const disputeUrlTU = whatsDifferentConfig?.disputeUrlTU;
  const disputeUrlEQ = whatsDifferentConfig?.disputeUrlEQ;
  const disputeUrlEX = whatsDifferentConfig?.disputeUrlEX;
  const blueNoteText = subSectionsBlueMessage?.[title?.toLowerCase()];
  const classNameBlueNotePanel = classnames('padTB16 m-pad16', {
    hide: !blueNoteText,
  });
  const handleReviewInReport = props => {
    handleOpenPanel(panelKey, sectionIds, props);
  };
  const onResolveNow = props => {
    if (disputeUrlTU) {
      const bureauKey = props?.bureau?.bureauKey;
      if (bureauKey === EQF) {
        goToUrlWithNewTab(disputeUrlEQ);
      } else if (bureauKey === EXP) {
        goToUrlWithNewTab(disputeUrlEX);
      } else {
        goToUrlWithNewTab(disputeUrlTU);
      }
    } else {
      if (enableToDispute) {
        handleResolveNow(props);
      }
    }
  };

  const seenPixel = useSeenModulePixel(
    getViewModuleTrackingAttributes(
      {
        moduleName: `Discrepancy - ${title}`,
        modulePosition,
      },
      modulePosition,
    ),
  );

  return (
    <>
      {seenPixel}
      <FlexContainer
        datatestid={datatestid}
        justifyBetween
        className="bgGrayN025 padTB10 padLR16 margB6 text-12 m-text-10 fontLatoNormal600 fontGray400 toUpper"
      >
        <Label datatestid={`${datatestid}-discrepencylabel`}>{title}</Label>
        <Label datatestid={`${datatestid}-discrepencycount`}>{subtitle}</Label>
      </FlexContainer>
      <FlexContainer className={classNameBlueNotePanel}>
        <Label className="bgLBlue0 text-14 m-text-12 borderRadius8 padTB12 padLR16 format100">
          <OText text={blueNoteText} />
        </Label>
      </FlexContainer>

      {bureaus?.map((bureau, index) => {
        return (
          <div key={index}>
            <DiscrepancyRow
              datatestid={datatestid}
              title={title}
              enableToDispute={enableToDispute}
              reportId={reportId}
              bureau={bureau}
              handleReviewInReport={handleReviewInReport}
              onResolveNow={onResolveNow}
            />
          </div>
        );
      })}
    </>
  );
};

export default DiscrepancyController;
